import { useTaxStore } from "../store/useTaxStore";
import { TAX_YEAR_CE_MIN } from "../types/tax.types";
import { cn } from "@/lib/utils";

const currentCEYear = new Date().getFullYear();
const CE_YEARS = Array.from(
  { length: currentCEYear - TAX_YEAR_CE_MIN + 1 },
  (_, i) => TAX_YEAR_CE_MIN + i,
);

export default function TaxHeader() {
  const { viewYear, setYear } = useTaxStore();

  return (
    <div className="mb-6">
      <div className="flex items-center gap-1.5 overflow-x-auto pb-1 scrollbar-none">
        {CE_YEARS.map((ceYear) => {
          const isSelected = ceYear === viewYear;
          return (
            <button
              key={ceYear}
              onClick={() => setYear(ceYear)}
              className={cn(
                "flex-shrink-0 px-3 py-1.5 rounded-full text-[13px] font-medium transition-colors whitespace-nowrap",
                isSelected
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted text-muted-foreground hover:bg-muted/70 hover:text-foreground",
              )}
            >
              {ceYear}
            </button>
          );
        })}
      </div>
    </div>
  );
}
